import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { main_url, fetchApi } from "../helper/api";
import WarningIcon from "@mui/icons-material/Warning";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Lightbox from "react-spring-lightbox";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ImageGallery from "./gallery";
import ImageMosaic from "./gallery/components/ImageMosaic";
import CoolLightbox from "./gallery/components/CoolLightBox";
import { Divider, Tooltip } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import "./assets/pagination.css";
import { renderSensorIcon } from "../helper/function";

const defaultDataHistory = {
  metaPagination: {
    currentPage: 0,
    dataCount: null,
    info: null,
    maxPage: null,
    pageSize: null,
  },
  thresholdHistory: [],
};

const defaultMosaicImages = [
  [
    {
      src: null,
      alt: "",
      caption: "",
      width: 1000,
      height: 1000,
    },
  ],
];

const HistoryTreshold = ({ type }) => {
  const [dataHistory, setDataHistory] = useState(defaultDataHistory);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [pageSize, setPageSize] = useState(10);
  const { id: idSensor } = useParams();
  // const [dataImages, setDataImages] = useState(defaultMosaicImages);
  const [dataImages, setDataImages] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isOpen, setOpen] = useState(false);
  const [currentImageIndex, setCurrentIndex] = useState(0);
  const [selectedImages, setSelectedImages] = useState(null);

  useEffect(() => {
    if (idSensor) {
      fetchHistoryData();
    }
  }, []);

  useEffect(() => {
    fetchHistoryData();
    setPage(0);
  }, [rowsPerPage]);

  useEffect(() => {
    fetchHistoryData();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, [page]);

  const fetchHistoryData = async () => {
    const req = await fetchApi(
      `api/ThresholdHistory?${type}=${idSensor}&page=${
        page + 1
      }&pageSize=${rowsPerPage}`,
      "get",
      true
    );
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      setDataHistory(res.data);
    } else {
      // console.log("ERROR FETCH HISTORY");
    }
  };

  useEffect(() => {
    if (dataHistory?.thresholdHistory?.length !== 0) {
      let tempDataImages = [];
      dataHistory.thresholdHistory.map((eachData) => {
        if (eachData.imagesPath.length > 0) {
          tempDataImages.push(
            eachData.imagesPath.map((image) => {
              return {
                src: image,
                alt: eachData.level,
                caption: eachData.createdAt,
                width: 4000,
                height: 2000,
                createdAt: eachData.createdAt,
                pesan: eachData.pesan,
                group: eachData.groupSensor,
              };
            })
          );
        }
      });
      // console.log("tempdataimages: ", tempDataImages);

      setDataImages(tempDataImages);
    }
  }, [dataHistory]);

  const translate = (timeStamp) => {
    let dift_s = (new Date().getTime() - new Date(timeStamp).getTime()) / 1000;
    let dift_d = Math.floor(dift_s / 86400);

    switch (true) {
      case dift_d === 0:
        switch (true) {
          case dift_s < 10:
            return "now";
          case dift_s < 60:
            return String(Math.floor(dift_s)) + " seconds ago";
          case dift_s < 3600:
            return String(Math.floor(dift_s / 60)) + " minutes ago";
          case dift_s < 86400:
            return String(Math.floor(dift_s / 3600)) + " hours ago";
          default:
        }
        return "now";

      case dift_d === 1:
        return "yesterday";
      case dift_d < 7:
        return String(dift_d) + " day ago";
      case dift_d < 31:
        return String(Math.floor(dift_d / 7)) + " week ago";
      case dift_d < 365:
        return String(Math.floor(dift_d / 31)) + " month ago";
      case dift_d > 365:
        return String(Math.floor(dift_d / 365)) + " year ago";
      default:
        return "-";
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = event.target.value;
    setRowsPerPage(parseInt(value, 10));
    setPage(0);
  };

  return (
    <div className="p-2">
      <div className="d-flex align-items-center mb-4">
        <span
          onClick={() => window.history.back()}
          className="mr-2"
          style={{ cursor: "pointer" }}
        >
          <i className="las la-arrow-left" style={{ fontSize: "30px" }}></i>
        </span>
        <h1 className="mb-0">History Treshold</h1>
      </div>
      <div
        className="box bg-white rounded-banget shadow"
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          padding: "30px 50px 30px 50px",
          gap: "20px",
          // alignItems: "center",
          // justifyContent: "center",
        }}
      >
        {dataHistory?.thresholdHistory.length > 0 ? (
          <>
            {dataImages &&
              dataHistory?.thresholdHistory.map((data, i) => {
                let imagesMosaic = dataImages[i];
                return (
                  <React.Fragment key={i}>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        // alignItems: "center",
                        gap: "10px",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span
                          style={{
                            display: "flex",
                            gap: "20px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignSelf: "center",
                              justifyContent: "center",
                              padding: "10px",
                              width: "50px",
                              height: "50px",
                              margin: "0px",
                              borderRadius: "50%",
                              backgroundColor:
                                data?.status === "1" ? "#f9a825" : "#EB0014",
                              boxShadow:
                                "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                            }}
                          >
                            {data?.status === "1" ? (
                              <WarningIcon
                                style={{ fontSize: "30px", color: "white" }}
                              />
                            ) : (
                              <PriorityHighIcon
                                style={{ fontSize: "30px", color: "white" }}
                              />
                            )}
                          </div>
                          <span
                            style={{
                              width: "fit-content",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "20px",
                            }}
                          >
                            <h3
                              style={{
                                padding: "0px",
                                margin: "0px",
                              }}
                            >
                              {data?.status === "1" ? "Warning" : "Danger"}{" "}
                              Threshold Reached
                            </h3>
                            <label
                              style={{
                                padding: "0px",
                                margin: "0px",
                                fontSize: "20px",
                              }}
                            >
                              -
                            </label>
                            <div
                              style={{
                                fontSize: "20px",
                                padding: "0px",
                                margin: "auto",
                                color: "#4686a5",
                              }}
                            >
                              ⏲️ {translate(data?.createdAt)}
                            </div>
                          </span>
                        </span>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                              justifyCenter: "center",
                            }}
                          >
                            <label
                              style={{
                                fontSize: "20px",
                              }}
                            >
                              {data?.groupSensor ?? "unknown"}
                            </label>
                            <img
                              src={renderSensorIcon(data?.groupSensor)}
                              alt="sensor"
                              width={50}
                              height={50}
                            />
                          </span>
                        </span>
                      </div>
                      <p
                        style={{
                          fontSize: "20px",
                          margin: "10px 0px",
                          padding: "0px",
                        }}
                      >
                        {data?.pesan}
                      </p>
                      {imagesMosaic && (
                        <>
                          <ImageMosaic
                            images={dataImages[i]}
                            handleClick={(e, { index }) => {
                              setSelectedImages(dataImages[i]);
                              setCurrentIndex(index);
                              setOpen(true);
                            }}
                          />
                          <CoolLightbox
                            currentImageIndex={currentImageIndex}
                            setCurrentIndex={setCurrentIndex}
                            isOpen={isOpen}
                            onClose={() => setOpen(false)}
                            images={selectedImages}
                          />
                        </>
                      )}
                    </div>
                    <Divider />
                  </React.Fragment>
                );
              })}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <TablePagination
                className="pagination"
                component="div"
                count={dataHistory?.metaPagination?.dataCount ?? 0}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </>
        ) : (
          <>{`History kosong!, tidak ada event ${type} terkena threshold`} </>
        )}
      </div>
    </div>
  );
};

export default HistoryTreshold;
